export default __webpack_public_path__ + "static/media/ChaltenManual40.1da6832b.jpg";